import { MobModel } from "types";

import BISHOP_HOLLOWLANDS_MOBS from "./hollowlands";
import BISHOP_LAUNCH_CHECK_MOBS from "./launchCheck";
import BISHOP_STRAYHOLD_MOBS from "./strayhold";

const BISHOP_MOBS: Record<string, MobModel> = {
  ...BISHOP_LAUNCH_CHECK_MOBS,
  ...BISHOP_HOLLOWLANDS_MOBS,
  ...BISHOP_STRAYHOLD_MOBS,
};

export default BISHOP_MOBS;
